import React from 'react';
import { config } from '@triare/auth-redux';
import Layout from '../../../components/Layout';
import MarathonsContent from '../../../components/Pages/Marathons/Trainings';

const { displayName } = config;

export default function MarathonTrainings(): React.ReactNode | null {
  document.title = `${displayName}: Редактировать тренировки`;

  return (
    <Layout>
      <MarathonsContent />
    </Layout>
  );
}
